"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var Bonus_1 = __importDefault(require("./Bonus"));
var VerificationSuccessful = function (_a) {
    var onClose = _a.onClose, setPrevStep = _a.setPrevStep;
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var t = (0, next_intl_1.useTranslations)('phoneVerification');
    var tDef = (0, next_intl_1.useTranslations)('translation');
    var openDepositHandler = (0, react_1.useCallback)(function () {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setPrevStep();
        openDeposit();
    }, [onClose, openDeposit, setPrevStep]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('verificationSuccessful')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description, dangerouslySetInnerHTML: {
                __html: t.raw("yourPhoneNumberSuccessfullyVerified"),
            } }),
        react_1.default.createElement(Bonus_1.default, null),
        react_1.default.createElement(ui_components_1.FixedButton, { height: "40px", width: "100%", type: "button", text: "upper", color: "gradient", maxWidth: "none", onClick: openDepositHandler }, tDef('deposit'))));
};
exports.default = VerificationSuccessful;
